var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcAppNavigationList,{class:_vm.$style.filesNavigationList,attrs:{"aria-label":_setup.t('files', 'Views')}},_vm._l((_setup.rootViews),function(view){return _c(_setup.FilesNavigationListItem,{key:view.id,attrs:{"view":view}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }